<template>
  <n-message-provider>
    <Email />
  </n-message-provider>
  <MostReadRight :data="mostRead" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useUrlSearchParams } from '@vueuse/core'
import { getPicDetailsMostReadMsg } from '@/services/picDetails'
import MostReadRight from '../MostReadRight'
import Email from '../Email'

const paramsUrls = useUrlSearchParams()
const mostRead = ref([])

const gettableDate = async () => {
  let response: ResponseResult<{
    mostRead: {
      fullColumnImgUrls: { url: string; };
      videoInfo: {
        videoDuration: number;
      };
      objectId: string;
      timeAgo: string;
      newsTitle: string;
      newsSummary: string;
      videoDuration: string;
      publishTime: string;
      objectType: string;
      mainChannel: any;
      liveInfo: any;
      photoNum: number;
    }[]
  }> = await getPicDetailsMostReadMsg()
  if (response) {
    mostRead.value = response.data.mostRead || []
  }
}

onMounted(() => {
  if (paramsUrls.promote == 'true') {
  } else {
    gettableDate()
  }
})


</script>

<style scoped lang="less">
@import "./style.less";
</style>
